import { Component } from '@angular/core';
import { EnvironmentService } from '../../services/env.service';

@Component({
    selector: 'app-user-manual',
    templateUrl: './user-manual.component.html',
    styleUrls: ['./user-manual.component.scss'],
    standalone: false
})
export class UserManualComponent {
  public supportEmail: string =
    EnvironmentService.getEnvironment().supportEmail;
  public userManualUrl: string = EnvironmentService.getEnvironment().userManualUrl;

  constructor() {}

}
